<script setup lang="ts">
import { Tag } from "~/components/clarity-ui/Tag";
import { Tint } from "~/components/clarity-ui/Tint";
import { useProductSubscriptionConfigurator } from "~/composables/shop/useProductSubscriptionConfigurator";
import CommonLabel from "~/templates/components/CommonLabel.vue";

export interface SubscriptionProductPriceProps {
  showOptionName?: boolean;
  optionButtonDefault?: boolean;
}

defineProps<SubscriptionProductPriceProps>();

const { product } = useProduct();

const { subscriptionTotalPrice, subscriptionListPrice } =
  useProductSubscriptionConfigurator(product);
</script>

<template>
  <div>
    <div class="flex items-center gap-2 text-2xl xl:text-3xl">
      <SharedPrice class="font-medium" :value="subscriptionTotalPrice" discounted />
      <Tint
        ><SharedPrice
          v-if="subscriptionListPrice && subscriptionListPrice !== subscriptionTotalPrice"
          strikethrough
          :value="subscriptionListPrice"
      /></Tint>
      <Tag class="ml-6 shrink-0 lg:ml-auto lg:mr-12" color="highlight"
        ><CommonLabel
          path="BWF/shop/productDetailPage/subscriptionProduct/subscriptionPriceBadgeLabel"
      /></Tag>
    </div>
    <Tint class="mt-1 text-sm" tag="p">
      <CommonLabel path="BWF/shop/productDetailPage/plus" />&nbsp;<CommonLabel
        path="BWF/shop/checkout/cart/taxes"
      />
    </Tint>
  </div>
</template>
